<template>
	<video
		:style="{
			zIndex: '999999999',
			position: 'fixed',
			right: '0',
			background: 'black',
		}"
		width="400"
		height="300"
		ref="videoPlayer"
		autoplay
	/>
</template>

<script>
	import Warnings from '@core/services/warningMessages';

	export default {
		name: 'Streamer',
		props: ['width', 'height'],
		data() {
			return {
				generatedWarnings: null,
				videoBuffer: null,
				mediaSource: null,
				sourceBuffer: null,
			};
		},
		computed: {},
		created() {
			this.generatedWarnings = new Warnings('Streamer');
		},
		beforeUnmount() {
			this.MeetingHubBus.off('sendBackBuffer', this.sendBackBufferEmitterHandler);
		},
		mounted() {
			this.applyInitStyling();
			const { handleSourceOpen } = this;
			const mimeType = 'video/webm; codecs="vp9,opus"';

			if (window.MediaSource) {
				this.mediaSource = new MediaSource();
				this.$refs.videoPlayer.src = URL.createObjectURL(this.mediaSource);
				this.mediaSource.addEventListener('sourceopen', handleSourceOpen);
			} else {
				console.warn('The Media Source Extensions API is not supported on your browser.');
			}

			this.MeetingHubBus.on('sendBackBuffer', this.sendBackBufferEmitterHandler);
		},
		methods: {
			async sendBackBufferEmitterHandler(data) {
				if (!data.bytes) console.warn("Streamer Component: sendBackBuffer EventHandler is expecting 'data' to contain bytes.");
				const binary_string = window.atob(data.bytes);
				const len = binary_string.length;
				const bytes = new Uint8Array(len);
				for (let i = 0; i < len; i++) {
					bytes[i] = binary_string.charCodeAt(i);
				}

				const blob = new Blob([bytes], { type: `${mimeType}` });
				this.videoBuffer = await blob.arrayBuffer();

				if (!this.sourceBuffer) {
					this.sourceBuffer = await new Promise((resolve, reject) => {
						const getSourceBuffer = () => {
							try {
								const sourceBuffer = this.mediaSource.addSourceBuffer(mimeType);
								resolve(sourceBuffer);
							} catch (e) {
								reject(e);
							}
						};
						if (this.mediaSource.readyState === 'open') {
							getSourceBuffer();
						} else {
							this.mediaSource.addEventListener('sourceopen', getSourceBuffer);
						}
					});
				}

				this.sourceBuffer.appendBuffer(this.videoBuffer);

				this.sourceBuffer.onupdateend = () => {
					//console.log("Appended data.");
					//this.mediaSource.endOfStream();

					this.$refs.videoPlayer.play();
				};
			},
			applyInitStyling() {
				const { videoPlayer } = this.$refs;
				if (this.width) {
					if (Number.isInteger(this.width)) {
						videoPlayer.width = this.width;
					} else {
						const { text, style } = this.generatedWarnings.wrongPropValue('width', "Couldn't set width.", 'Number');

						console.warn(text, style);
					}
				}
				if (this.height) {
					if (Number.isInteger(this.height)) {
						videoPlayer.height = this.height;
					} else {
						const { text, style } = this.generatedWarnings.wrongPropValue('height', "Couldn't set height.", 'Number');

						console.warn(text, style);
					}
				}
			},
			handleSourceOpen() {
				// TODO:
				// console.log("MediaSource - opened.");
			},

			checkSupportedType(mimeType) {
				if (MediaSource.isTypeSupported(mimeType)) {
					return true;
				}
				return false;
			},
		},
		components: {},
	};
</script>

<style></style>
